import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {Router} from '@angular/router';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {RegionCode} from '../../../app.env.config';
import {RegionService} from '../../../services/region.service';
import {StorageService} from '../../../services/storage.service';
import {SupabaseAuthService} from '../../../services/supabase-auth.service';

@Component({
  selector: 'app-debug-setting',
  imports: [NzButtonModule],
  templateUrl: './debug-setting.component.html',
  styleUrl: './debug-setting.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DebugSettingComponent {
  protected readonly RegionCode = RegionCode;
  private readonly storageService = inject(StorageService);
  private readonly regionService = inject(RegionService);
  private readonly supabaseAuthService = inject(SupabaseAuthService);
  private readonly router = inject(Router);

  async setDebugRegion(region: RegionCode.LOCAL | RegionCode.LOCAL_PROD) {
    await this.storageService.lfSet('debugMode', true);
    await this.regionService.setRegion(region);
    this.supabaseAuthService.resetClient();
    await this.router.navigate(['/account/login']);
  }

  async disableDebugMode() {
    await this.storageService.lfRemove('debugMode');
    // Leaving a debug-only region active would desync API and Auth selection.
    await this.regionService.setRegion(RegionCode.US);
    this.supabaseAuthService.resetClient();
    await this.router.navigate(['/account/login']);
  }
}
